import Vue from 'vue';
import EdPdfjsExpress from './ed-pdfjs-express/ed-pdfjs-express.component.vue';
import EdPdfjs from './ed-pdfjs/ed-pdfjs.component.vue';
import EdFileLoader from './ed-file-loader/ed-file-loader.component.vue';

export const FilesComponents = {
  EdPdfjs: Vue.component('ed-pdfjs', EdPdfjs),
  EdFileLoader: Vue.component('ed-file-loader', EdFileLoader)
}